import { render, staticRenderFns } from "./compromiso-ian.vue?vue&type=template&id=c145f5d4&scoped=true&lang=html"
import script from "./compromiso-ian.vue?vue&type=script&lang=js"
export * from "./compromiso-ian.vue?vue&type=script&lang=js"
import style0 from "./compromiso-ian.vue?vue&type=style&index=0&id=c145f5d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c145f5d4",
  null
  
)

export default component.exports